export default __webpack_public_path__ + "static/enterprise-circle-beff8ef9a2e8a0bd22ea528baed1af89.png";